var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-table" }, [
    _c(
      "table",
      {
        class: "dataTable table " + _vm.tableClass,
        attrs: { id: "dataTable" }
      },
      [
        _vm._t("thead", [
          _c("thead", [
            _c(
              "tr",
              _vm._l(_vm.fields, function(value, index) {
                return _c("th", { key: index }, [
                  _vm._v("\n            " + _vm._s(value) + "\n          ")
                ])
              }),
              0
            )
          ])
        ]),
        _vm._v(" "),
        _vm._t("tbody", [
          _c(
            "tbody",
            [
              _c("tr", [
                _vm.items.length === 0
                  ? _c(
                      "td",
                      {
                        staticClass: "text-center",
                        attrs: { colspan: _vm.items.length }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("message.notfounddata")) +
                            "\n          "
                        )
                      ]
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm._l(_vm.items, function(columns, columnsIndex) {
                return _c(
                  "tr",
                  { key: columnsIndex },
                  _vm._l(columns, function(value, index) {
                    return _c("td", { key: index }, [
                      _vm._v("\n            " + _vm._s(value) + "\n          ")
                    ])
                  }),
                  0
                )
              })
            ],
            2
          )
        ])
      ],
      2
    ),
    _vm._v(" "),
    !_vm.hidePagination
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-end" },
          [
            _c("div", { staticClass: "col d-flex align-items-center" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$t("message.rows", { number: _vm.pagination.totalRows })
                  ) +
                  "\n    "
              )
            ]),
            _vm._v(" "),
            _c("b-pagination", {
              staticClass: "pagination",
              attrs: {
                value: _vm.pagination.currentPage,
                totalRows: _vm.pagination.totalRows,
                perPage: _vm.pagination.perPage
              },
              on: { change: _vm.handlePageChange }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8c0fb7a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c0fb7a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/BaseTable.vue
// module id = null
// module chunks = 